var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For developer - BOF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24293,
    height: 7570,
    transform: "translate(-1669 -3737)",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Caselista",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1183,
    transform: "translate(-923 -292)",
    fill: "#F2FAFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 217",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -498,
    y: -28,
    width: 1420,
    height: 940,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 9.25893C0.00515352 9.23833 0.0103045 9.21772 0.0103045 9.19197C0.0566862 7.76513 0.401973 6.4207 1.05132 5.15355C1.4636 4.34483 1.98926 3.60823 2.61799 2.95405C3.76207 1.759 5.11745 0.914233 6.69958 0.419732C7.22008 0.260049 7.7509 0.146726 8.28686 0.0746116C8.80737 0.00764792 9.33303 -0.0129563 9.85869 0.00764792C10.7915 0.0437053 11.6985 0.218841 12.5797 0.527904C13.2445 0.759701 13.8733 1.06361 14.4711 1.42934C14.7906 1.62508 14.904 1.98565 14.7494 2.29986C14.5742 2.65014 14.1464 2.77891 13.8114 2.57287C13.3322 2.27926 12.8271 2.02686 12.3015 1.83627C11.7706 1.64053 11.2244 1.50145 10.6626 1.41904C10.1782 1.34692 9.68862 1.31601 9.19904 1.33662C8.13741 1.37783 7.12216 1.61478 6.1533 2.04746C5.26174 2.44925 4.4681 2.99011 3.77238 3.67004C2.75198 4.6642 2.04595 5.84894 1.64397 7.21912C1.51513 7.66726 1.42237 8.12055 1.37084 8.58414C1.32445 8.98593 1.30384 9.38256 1.32445 9.78434C1.3966 11.4996 1.92742 13.0553 2.96327 14.4203C4.06098 15.8677 5.48335 16.8361 7.23039 17.3461C7.65298 17.4697 8.08072 17.5521 8.51877 17.6036C8.91044 17.65 9.3021 17.6706 9.69377 17.6603C11.0285 17.6191 12.2808 17.2894 13.4507 16.6352C14.8731 15.842 15.9553 14.719 16.7232 13.2922C17.1303 12.535 17.4034 11.7314 17.5477 10.8867C17.6096 10.5364 17.6457 10.181 17.6611 9.82555C17.7178 8.43992 17.4292 7.1264 16.8056 5.88499C16.6819 5.63774 16.5376 5.39565 16.3985 5.1587C16.1666 4.77237 16.3727 4.27272 16.8159 4.1697C17.0891 4.10788 17.3725 4.22121 17.5271 4.46846C17.9033 5.06083 18.2074 5.68926 18.4445 6.35374C18.6506 6.93581 18.8 7.52818 18.8928 8.14115C18.9856 8.73868 19.0113 9.34135 18.9856 9.94402C18.934 11.0463 18.7021 12.1075 18.2795 13.1222C17.8209 14.2348 17.1715 15.2187 16.3367 16.0841C15.2802 17.1812 14.0382 17.9797 12.6004 18.4793C12.0335 18.675 11.4511 18.8193 10.8533 18.9068C10.4668 18.9635 10.0751 19.0047 9.68347 18.9996C9.34333 18.9944 9.0032 18.9996 8.66822 18.9687C7.51383 18.8708 6.41098 18.5669 5.36997 18.0621C4.40626 17.5933 3.54562 16.9855 2.78805 16.2283C1.60274 15.0436 0.793642 13.6373 0.350439 12.025C0.226754 11.5821 0.133989 11.1288 0.0876073 10.6703C0.0566862 10.3922 0.0463798 10.1089 0.0206122 9.8307C0.0206122 9.81009 0.0103045 9.78949 0.0103045 9.77404C-2.51652e-06 9.5886 0 9.42377 0 9.25893Z",
    fill: "#EDE60A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.12203 13.1429C7.25602 12.9832 7.3797 12.8338 7.50854 12.6793C8.23003 11.8139 8.95153 10.9485 9.67817 10.0831C10.3533 9.27441 11.0335 8.46055 11.7087 7.65183C12.4302 6.78646 13.1516 5.92623 13.8731 5.06086C14.0535 4.84966 14.2287 4.63332 14.4091 4.42213C14.6565 4.13367 15.1306 4.10791 15.3934 4.37577C15.6356 4.62817 15.6511 5.0248 15.4244 5.29265C14.6822 6.17863 13.9453 7.06461 13.2083 7.95059C12.559 8.72325 11.9148 9.50106 11.2655 10.2737C10.3584 11.3606 9.44626 12.4526 8.53924 13.5395C8.26611 13.8691 7.99297 14.1937 7.71984 14.5233C7.51369 14.7706 7.20964 14.8633 6.9365 14.7551C6.84889 14.7191 6.76643 14.6676 6.69944 14.6006C5.66873 13.5755 4.63803 12.5453 3.61248 11.5151C3.42695 11.3297 3.37026 11.103 3.44241 10.8558C3.51456 10.6137 3.67947 10.454 3.92684 10.3973C4.16906 10.3407 4.38551 10.4076 4.56073 10.5828C5.29253 11.3142 6.02948 12.0508 6.76128 12.7823C6.86435 12.8853 6.96742 12.9883 7.07049 13.0913C7.0808 13.1068 7.10141 13.1171 7.12203 13.1429Z",
    fill: "#EDE60A"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -532,
    y: -62,
    width: 1488,
    height: 1008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1183,
    fill: "white",
    transform: "translate(-923 -292)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComing);
export default __webpack_public_path__ + "static/media/coming.95d4b4232ac0cec812ec39ba3557683e.svg";
export { ForwardRef as ReactComponent };